import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { TeachingHallCommentInput } from '../../../lib/types/models/ol/teaching-hall-comment/teaching-hall-comment-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { createStringSchema } from '../../../lib/utils/validations/string-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ValidationButtons from '../../elements/validation-buttons'

const formSchema: ZodType<TeachingHallCommentInput> = z.object({
  comment: createStringSchema('a Comment', { language: 'en' })
})

export function TeachingHallCommentForm({
  defaultValues,
  ...validationButtonProps
}: BaseFormProps<TeachingHallCommentInput, true>) {
  const form = useForm<TeachingHallCommentInput>({
    resolver: zodResolver(formSchema),
    defaultValues: defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}
        className="p-5"
      >
        <FormField
          control={form.control}
          name="comment"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledInput {...field} required label="Comment" type="text" />
              </FormControl>
            </FormItem>
          )}
        />
        <div className="h-4" />

        <div>
          <ValidationButtons {...validationButtonProps} />
        </div>
      </form>
    </Form>
  )
}
